/**
 * O desvio pelo gov.br: o pedido foi aberto no provedor, e a tela espera a
 * pessoa confirmar lá e voltar. O gov.br só VALIDA quem é a pessoa; o CPF
 * confirmado segue para o cadastro do DTP (D-12), e sem ele não há inscrição.
 */

import { ArrowLeft, Loader2, RefreshCw, ShieldCheck } from 'lucide-react';

import { Button } from '@/ui/base/button';

import { AvisoDoPasso } from './AvisoDoPasso';
import { type PropsDoPassoDaIdentidade } from './maquinaDeIdentidade';

export function IdentidadeGovbr({ estado, despachar, acoes }: PropsDoPassoDaIdentidade) {
  return (
    <div className="space-y-4">
      <p className="flex gap-2 rounded-xl border border-primary/30 bg-primary/5 p-3 text-sm text-foreground">
        <ShieldCheck aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
        <span>
          Abrimos o pedido de confirmação no gov.br. Conclua a confirmação lá — com conta de selo
          prata ou ouro — e volte aqui.
        </span>
      </p>

      <AvisoDoPasso aviso={estado.aviso} />

      <Button
        type="button"
        className="w-full"
        disabled={estado.ocupado}
        onClick={() => void acoes.confirmarGovbr()}
      >
        {estado.ocupado ? (
          <Loader2 aria-hidden="true" className="animate-spin" />
        ) : (
          <RefreshCw aria-hidden="true" />
        )}
        Já confirmei no gov.br
      </Button>

      <Button
        type="button"
        variant="ghost"
        className="w-full"
        onClick={() => despachar({ tipo: 'ir_para', passo: 'cpf' })}
      >
        <ArrowLeft aria-hidden="true" />
        Usar o CPF e o código
      </Button>
    </div>
  );
}

export default IdentidadeGovbr;
